export const reportStructure = {
    visitDate: '',
    visitTypeId: '',
    municipalityId: '',
    street: '',
    exteriorNumber: '',
    interiorNumber: '',
    zipCode: '',
    colony: '',
    latitude: '',
    longitude: '',
    rpu: '',
    accessSite: '',
    reasonNoAccessId: '',
    keepServiceActive: '',
    problemResolutionComments: '',
    files: [],
    staffs: [],
    internalComments: '',
    siteTypeId: '',
    connectionTypeId: '',
    wireBandWidthTest: '',
    wifiBandWidthTest: '',
    startingComments: '',
    installedIDSameSite: '',
    problemDetected: '',
    apsMerakiNumber: '',
    apsHuaweiNumber: '',
    mainEquipmentSerialNumber: '',
    lanSegment: '',
    siteActivitiesComments: '',
    additionalAps: '',
    externalFailures: '',
    requireTicket: '',
    folio: '',
    failureType: '',
    validatedEquipments: [],
    withDrawalReason: '',
    withDrawalEquipments: [],
    liftingObjective: '',
    requirementScenario: '',
    attendedUserComments: '',
    coverageWifiComments: '',
    attendedName: '',
    attendedTelephone: '',
    attendedPuesto: '',
    attendedEmail: '',
    installationServiceEquipments: [],
    originPointLinkID: '',
    bandWidthDelivered: '',
    bandWidthTest: '',
    fiberMetersInstalled: '',
    lanAddressIPAssigned: '',
    OLTName: '',
    secondLevelSplitter: ''
}
